import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';
import { createSlice } from '@reduxjs/toolkit';

import type {
  CredentialRead,
  CredentialTypeRead,
} from '../external/bambi-api/bambiApi';

export interface ICredentialState {
  credentialSearchTerm: string;
  selectedCredential?: CredentialRead;
  selectedCredentialType?: CredentialTypeRead;
  selectedCredentialTypeOption?: SelectOption;
  selectedCredentialTypes: string[];
  selectedMembers: string[];
  selectedVehicles: string[];
  newCredentialTypeName: string;
  showCredentialModal: boolean;
  showCredentialTypeModal: boolean;
}

export const initialState: ICredentialState = {
  credentialSearchTerm: '',
  selectedCredential: undefined,
  selectedCredentialType: undefined,
  selectedCredentialTypeOption: undefined,
  selectedCredentialTypes: [],
  selectedMembers: [],
  selectedVehicles: [],
  newCredentialTypeName: '',
  showCredentialModal: false,
  showCredentialTypeModal: false,
};

export const credentialSlice = createSlice({
  name: 'credential',
  initialState,
  reducers: {
    setCredentialSearchTerm: (state, action) => {
      state.credentialSearchTerm = action.payload;
    },
    setSelectedCredential: (state, action) => {
      state.selectedCredential = action.payload;
    },
    setSelectedCredentialType: (state, action) => {
      state.selectedCredentialType = action.payload;
    },
    setSelectedCredentialTypeOption: (state, action) => {
      state.selectedCredentialTypeOption = action.payload;
    },
    setSelectedCredentialTypes: (state, action) => {
      state.selectedCredentialTypes = action.payload;
    },
    setSelectedMembers: (state, action) => {
      state.selectedMembers = action.payload;
    },
    setSelectedVehicles: (state, action) => {
      state.selectedVehicles = action.payload;
    },
    setNewCredentialTypeName: (state, action) => {
      state.newCredentialTypeName = action.payload;
    },
    setShowCredentialModal: (state, action) => {
      state.showCredentialModal = action.payload;
    },
    setShowCredentialTypeModal: (state, action) => {
      state.showCredentialTypeModal = action.payload;
    },
    onClearFilters: (state) => {
      state.selectedCredentialTypes = [];
      state.selectedMembers = [];
      state.selectedVehicles = [];
    },
  },
});

export const {
  setCredentialSearchTerm,
  setSelectedCredential,
  setSelectedCredentialType,
  setSelectedCredentialTypeOption,
  setSelectedCredentialTypes,
  setSelectedMembers,
  setSelectedVehicles,
  setNewCredentialTypeName,
  setShowCredentialModal,
  setShowCredentialTypeModal,
  onClearFilters,
} = credentialSlice.actions;
